import { createSlice } from '@reduxjs/toolkit';
import { fetchRevenueSubscriptions } from '../subscriptionApi';

const fetchRevenueSubscriptionsSlice = createSlice({
    name: 'subscription/fetchRevenueSubscriptions',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchRevenueSubscriptions cases
            .addCase(fetchRevenueSubscriptions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRevenueSubscriptions.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchRevenueSubscriptions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default fetchRevenueSubscriptionsSlice.reducer;
